import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "tooltip"];

  copy() {
    let value = this.inputTarget.value;

    this.tooltipTarget.style.opacity = 1;
    this.tooltipTarget.style.visibility = "visible";

    setTimeout(() => {
      this.tooltipTarget.style.opacity = 0;
    }, 2000);

    navigator.clipboard.writeText(value);
  }
}
